import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../../../constants/colors';
import { fontSize } from '../../../../../constants/text';

const StyledContainer = styled.div.withConfig({ componentId: 'sc-1fah9z9-0' })`
  text-align: center;
  font-size: ${fontSize.mediumSmall};
  line-height: 20px;
  color: ${colors.gray500};
  padding-top: 4px;
  padding-bottom: 16px;
`;

const AtHomeCareSlotDisclaimer = () => {
  return (
    <StyledContainer>
      We will call you momentarily to confirm a time window for your at-home visit.
    </StyledContainer>
  );
};

export default AtHomeCareSlotDisclaimer;
